import React, { useState } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faFileArrowUp } from "@instadeepai/fontawesome-pro-regular"

type FileUploadProps = {
  inputRef: React.RefObject<HTMLInputElement>
  onDrop: (e: React.DragEvent<HTMLDivElement>) => void
  onDragOver: (e: React.DragEvent<HTMLDivElement>) => void
  onClick: () => void
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
}

export function FileUpload({
  inputRef,
  onDrop,
  onDragOver,
  onClick,
  onChange,
}: FileUploadProps) {
  const [isDragActive, setIsDragActive] = useState(false)

  return (
    <div
      className={`flex cursor-pointer flex-col items-center justify-center gap-3 rounded-md border border-gray-200 px-3.5 py-6 text-sm transition hover:bg-gray-100 
        ${isDragActive ? "animate-pulse border-2 border-dashed border-primary-700" : ""}
      `}
      onDrop={(e) => {
        setIsDragActive(false)
        onDrop(e)
      }}
      onDragOver={(e) => {
        setIsDragActive(true)
        onDragOver(e)
      }}
      onDragEnter={() => setIsDragActive(true)}
      onDragLeave={() => setIsDragActive(false)}
      onClick={onClick}
    >
      <FontAwesomeIcon
        icon={faFileArrowUp}
        className="rounded-full bg-gray-100 px-2 py-1.5 text-center text-gray-600"
      />
      <input
        type="file"
        multiple
        ref={inputRef}
        className="hidden"
        onChange={onChange}
      />
      <p className="text-center font-medium">
        <span className="text-primary-500">Click to upload</span> or Drag and
        drop
      </p>
    </div>
  )
}
